module.exports = __webpack_public_path__ + "static/media/ic-logo-afpa.0eedcd3c.svg";